export default __webpack_public_path__ + "static/media/pics.afef1458.png";